import { NavLink as RouterLink, useNavigate, useSearchParams } from 'react-router-dom'
import InputField from '../components/InputField'
import Btn from '../components/Btn'

import { Box, Link, Typography, useMediaQuery } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'

import logo from '../assets/images/logo-lg.svg'
import { PATH_LOGIN } from '../routes/constant'
import { usePostForgotPasswordMutation } from '../redux/api/userApi'
import useToken from '../hooks/useToken'
import ErrorMessage from '../components/ErrorMessage'
import { useEffect, useState } from 'react'

const Label = styled(Typography)(({ theme }) => ({
  color: '#6B7A99',
  fontSize: 12,
  fontWeight: 700,
  marginBottom: '13px'
}))

const PageText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[65],
  fontWeight: 500,
  lineHeight: '16.5px',
  marginBottom: '34px',
  [theme.breakpoints.down('lg')]: {
    textAlign: 'center'
  }
}))

const PasswordResetPage: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const emailFromQuery = searchParams.get('email')
  const [forgotPassword, { isLoading, isSuccess, error, isError }] = usePostForgotPasswordMutation()
  const [email, setEmail] = useState<string>(emailFromQuery ?? '')
  const { xsrf } = useToken()
  const onForgot = async () => {
    await forgotPassword({
      email,
      xsrf
    })
  }

  useEffect(() => {
    if (isSuccess) {
      navigate(PATH_LOGIN.PASSWORD_SENT, { state: { email, xsrf } })
    }
  }, [isSuccess])

  return (
        <Box>
            <Box
                component='img'
                src={logo}
                sx={{
                  display: isMobile ? 'block' : 'none',
                  height: '70px',
                  margin: '0 auto 50px',
                  width: '189px'
                }}
            />
            <Typography sx={{
              color: '#000',
              fontSize: 24,
              mb: '27px',
              textAlign: isMobile ? 'center' : 'left'
            }} variant='h2'>Reset Your Password</Typography>
            <PageText variant='h6'>
                Enter the email address associated with your account and we`ll send you a link to reset your password.
            </PageText>
            <form>
                <Box sx={{
                  display: 'flex',
                  gap: '24px',
                  flexDirection: 'column',
                  mb: '29px'
                }}>
                    <Box>
                        <Label>Email</Label>
                        <InputField aria-invalid={isError} value={email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setEmail(e.target.value)
                        }} error={isError} type='email' id='email' fullWidth/>
                    </Box>
                </Box>
                <Btn disabled={isLoading} onClick={onForgot} variant='contained' color='secondary' text='Continue' type='submit' sx={{
                  cursor: 'pointer',
                  fontSize: '14px',
                  p: '18px 0 ',
                  width: '100%'
                }}/>
            </form>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              m: '26px 0 0'
            }}>
                <Link
                    component={RouterLink}
                    to={PATH_LOGIN.LOGIN}
                    underline="none"
                    sx={{
                      color: theme.palette.secondary.main,
                      m: 0
                    }}
                >Return to Sign In</Link>
            </Box>
            <ErrorMessage error={error} />
        </Box>
  )
}

export default PasswordResetPage
